export function orderRegStatusItem(regStatus) {
  const statusItem = () => {
    if (regStatus === 'PENDING') {
      return {
        title: "審核中",
        class: "isStyleWarning",
        titleClass: "text-warning",
        qrCodeTitle: "報名審核中，暫無電子憑證。若審核通過，即可查看電子憑證。",
        onlineTitle: "審核通過後，即可查看直播連結",
      }
    } else if (regStatus === 'BLOCKED') {
      return {
        title: "審核不通過",
        class: "isStyleGray",
        titleClass: "text-gray-5",
        qrCodeTitle: "審核不通過。",
        displayOnlineButton: false
      }
    } else if (regStatus === 'WAITING') {
      return {
        title: "候補",
        // title: "備取中",
        class: "isStyleInfo",
        titleClass: "text-waiting",
        qrCodeTitle: "報名候補中，暫無電子憑證。若備取成功，即可查看電子憑證。",
        onlineTitle: "報名候補中，即可查看直播連結",
      }
    } else if (regStatus === 'CONFIRMED') {
      return {
        title: "報名成功",
        class: "isStylePrimary",
        titleClass: "color-primary",
        qrCodeTitle: "一張憑證可供此報名中的全部活動/課程使用",
      }
    } else if (regStatus === 'CANCELED') {
      return {
        title: "報名取消",
        class: "isStyleCancel",
        titleClass: "text-cancel",
        qrCodeTitle: "報名已取消。",
        displayOnlineButton: false,
        onlineTitle: "報名已取消",
      }
    }
  };

  return {
    title: statusItem().title || '',
    class: statusItem().class || '',
    titleClass: statusItem().titleClass || '',
    qrCodeTitle: statusItem().qrCodeTitle || '',
    onlineTitle: statusItem().onlineTitle || '查看線上直播',
    displayOnlineButton: statusItem().displayOnlineButton || true,
  }
}


export function orderCheckinStatusItem(checkinStatus) {
  const statusItem = () => {
    if (checkinStatus === 'FORBIDDEN') {
      return {
        title: "禁止報到",
        class: "isStyleGray",
      }
    } else if (checkinStatus === 'CHECKIN') {
      return {
        title: "待報到",
        class: "isStyleWarning",
      }
    } else if (checkinStatus === 'CHECKEDIN') {
      return {
        title: "已報到",
        class: "isStylePrimary",
      }
    } else if (checkinStatus === 'NOSHOW') {
      return {
        title: "未報到",
        class: "isStyleDanger",
      }
    } else if (checkinStatus === 'COMPLETED') {
      return {
        title: "已完成",
        class: "isStyleSuccess",
      }
    }
  };

  return {
    title: statusItem().title || '',
    class: statusItem().class || '',
  }
}

/**
 * 顯示QrCode
 * @param showQrcode
 * @oaran sessions
 * @returns {{title: string, qrCodeTitle: string}}
 */
export function orderShowQrcode(showQrcode, regStatus) {
  const statusItem = () => {
    if (showQrcode && regStatus !== 'CONFIRMED') {
      return {
        title: "部分報名成功",
        qrCodeTitle: "部分活動/課程報名成功，一張憑證可供此報名成功的活動/課程使用",
      }
    } else {
      return orderRegStatusItem(regStatus)
    }
  };

  return {
    title: statusItem().title || '',
    qrCodeTitle: statusItem().qrCodeTitle || '',
  }
}